<template>
  <div>
    <b-table 
      :items="criterias"
      :fields="fields"
      :filter="searchString"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :per-page="perPage"
      :current-page="currentPage"
      responsive
      show-empty
      ref="criteriasTable"
      class="mt-2"
      thead-class="esep-blue-bg text-light"
    >      
      <template v-slot:cell(action)="row">
        <b-button
          size="sm"
          @click="deleteCriteria(row)"
          variant="transparent"
          v-b-tooltip.hover
          :title="$t('parametrics.deleteCriteria')"
        >
          <b-icon icon="trash" ></b-icon>
        </b-button>
      </template>

      <template v-slot:empty="">
        <h6>{{ $t("parametrics.emptyCriteriasTable") }}</h6>
      </template>

    </b-table>

    <b-row>
      <b-col>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          aria-controls="criterias-table"
          variant="info"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import trainingService from '../../services/training.service';
import {handleApiError} from "../../services/error.service";

export default {
  computed: {
    rows() {
      return this.criterias? this.criterias.length : 0;
    }
  },
  props: {
    module: Object,
    criterias: Array,
    evalType: String
  },
  data() {
    return {
      popSuccessAlert: false,
      successMessage: null,
      perPage: 10,
      currentPage: 1,
      pageOptions: [
        10,
        20,
        50,
        {
          value: Number.MAX_SAFE_INTEGER,
          text: "All",
        },
      ],
      sortBy: "category",
      sortDesc: false,
      fields: [
        { key: "title", label: "Θέματα στην Ενότητα", sortable: true , thClass: 'text-left', tdClass: 'text-left'},
        { key: "description", label: "Περιγραφή", sortable: false, thClass: 'text-left', tdClass: 'text-left descWidth', formatter: "prettifyEmpty"},
        { key: "criteriaContentType", label: "Τύπος Κριτηρίου", sortable: true, sortByFormatted: true, formatter: "translateContentType", thClass: 'text-left', tdClass: 'text-left' },
        { key: "criteriaLowDescription", label: "Χαμηλότερη Βαθμολόγηση", sortable: false , formatter: "prettifyEmpty", thClass: 'text-left', tdClass: 'text-left'},
        { key: "criteriaHighDescription", label: "Υψηλότερη Βαθμολόγηση", sortable: false , formatter: "prettifyEmpty", thClass: 'text-left', tdClass: 'text-left'},
        { key: "category", label: "Κατηγορία", sortable: true, sortByFormatted: true, formatter: "showCategoryTitle", thClass: 'text-left', tdClass: 'text-left' },
        { key: "action", label: "Ενέργεια", sortable: false  }
      ],
      filterOn: ["title"],
      searchString: "",
      
    }
  },
  methods: {
    prettifyEmpty(item) {
      return item ? item : "-";
    },
    showCategoryTitle(category) {
      return category ? category.title : "-";
    },
    translateContentType(contentType) {
      return contentType ? this.$t('criteriaTypeEnums.'+ contentType) : "-";
    },
    deleteCriteria(row) {
      let criteria = row.item;
      criteria.criteriaStatus = 'INACTIVE';
      this.$log.debug(criteria)
      trainingService.updateCriteria(this.evalType != 'TRAINER' ? this.evalType.toLowerCase() : 'leader', row.item).then(
        (response) => {
          this.$log.debug(response.data);
          this.$emit('refresh-list',this.$t('parametrics.criteriaDeleted'));
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
  }
}
</script>

<style>
.descWidth {
  max-width: 20rem;
  min-width: 20rem;
}
</style>